<template>
  <v-dialog
    class="forward-dialog"
    width="500px"
    :title="'Select Recipient'"
    :visible.sync="forwardDialogVisible"
    @closed="onClosed"
    @open="onOpen"
  >
    <div class="form-wrap">
      <el-scrollbar class="custom">
        <el-form
          ref="forwardForm"
          :model="forwardForm"
          label-position="top"
          :rules="forwardFormRules"
        >
          <div class="content">
            <el-form-item prop="forwardTo" label="Receiver">
              <el-select
                ref="forwardToSelect"
                v-model="forwardForm.forwardTo"
                placeholder="Please enter the recipient"
                clearable
                filterable
              >
                <el-option
                  v-for="itemML in forwardList"
                  :key="itemML.UserID"
                  :label="itemML.Name + '(' + itemML.Email + ')'"
                  :value="itemML.LoginName"
                  style="text-align: left"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Comments" prop="comment">
              <el-input
                v-model="forwardForm.comment"
                :autosize="{ minRows: 6 }"
                readonly
                type="textarea"
              />
            </el-form-item>
          </div>
        </el-form>
      </el-scrollbar>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmit"> Confirm </el-button>
      <el-button plain @click="onClosed"> Cancel </el-button>
    </div>
  </v-dialog>
</template>

<script>
//import moment from "moment";
export default {
  name: "fowrard-meeting-dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Object,
  },
  data() {
    return {
      forwardDialogVisible: this.visible,
      forwardList: [],
      forwardForm: {
        meetingId: "",
        requestId: "",
        forwardTo: "",
        forwardFrom: "",
        comment: "",
        modifyDt: "",
        Host: "",
        //forwardNumber:[],
        //remark:"",
      },
      forwardStatus: "",
      forwardFormRules: {
        forwardTo: [
          { required: true, message: "Please fill in the recipient" },
        ],
      },
    };
  },
  computed: {
    userName() {
      return this.$store.state.userInfo.name;
    },
  },
  watch: {
    visible(value) {
      this.forwardDialogVisible = value;
    },
    "forwardForm.forwardTo"(value) {
      let commentForward = this.data.CommentForward;
      commentForward =
        commentForward && commentForward !== "null" ? commentForward : "";
      if (value) {
        const user = this.findUserNameById(value);
        if (user) {
          this.findUserNameById(value);
          this.forwardForm.comment = `${commentForward}${this.userName}:会议从${this.forwardForm.forwardForm}转发给${user.Name}\n`;
        }
      } else {
        this.forwardForm.comment = commentForward;
      }
    },
  },
  methods: {
    onClosed() {
      this.$emit("update:visible", false);
      this.$emit("data", null);
      this.$refs.forwardForm.resetFields();
    },
    onOpen() {
      this.$nextTick(() => {
        if (this.data) {
          if (this.data.Id != "" && this.data.Id != null) {
            this.forwardStatus = "forwardRequest";
            this.forwardForm.requestId = this.data.Id;
            this.forwardForm.forwardForm = this.data.Name;
            this.forwardForm.Host = this.data.Owner;
            Object.assign(this.forwardForm, this.data);
          } else {
            this.forwardStatus = "forwardMeeting";
            this.forwardForm.meetingId = this.data.MeetingId;
            this.forwardForm.comment = this.data.CommentForward;
            this.forwardForm.forwardForm = this.data.Name;
            this.forwardForm.Host = this.data.Host;
            Object.assign(this.forwardForm, this.data);
          }
        }
        this.getForwardList();
        // 适配ios 软盘不抬起问题
        let elSelectInput =
          this.$refs.forwardToSelect.$el.querySelector("input");
        elSelectInput.removeAttribute("readOnly");
        elSelectInput.onblur = function () {
          setTimeout(() => {
            elSelectInput.removeAttribute("readOnly");
          }, 200);
        };
      });
    },
    findUserNameById(userId) {
      return this.forwardList.find((x) => x.LoginName === userId);
    },
    handleSubmit() {
      this.$refs.forwardForm.validate((valid) => {
        if (valid) {
          this.$confirm(
            "Please make sure if it is ready to forward？",
            "Attention",
            { confirmButtonText: "Confirm", cancelButtonText: "Cancel" }
          ).then(() => {
            if (this.forwardStatus == "forwardRequest") {
              this.axios
                .post("/meetingReq/forward", {
                  reqId: this.forwardForm.requestId,
                  forwardTo: [this.forwardForm.forwardTo],
                  comment: this.forwardForm.comment,
                })
                .then((res) => {
                  if (res.code == 200) {
                    this.$message({
                      type: "success",
                      message: "Forward meeting request successfully",
                    });
                    this.$emit("update:visible", false);
                    this.$emit("success");
                  } else {
                    this.$message({
                      type: "error",
                      message: res.msg,
                    });
                  }
                })
                .catch((err) => {
                  this.$message({
                    type: "info",
                    message: "error: " + err,
                  });
                });
            }
            if (this.forwardStatus == "forwardMeeting") {
              this.axios
                .post("/meeting/forward", {
                  meetingId: this.forwardForm.meetingId,
                  forwardTo: [this.forwardForm.forwardTo],
                  comment: this.forwardForm.comment,
                })
                .then((res) => {
                  if (res.code == 200) {
                    this.$message({
                      type: "success",
                      message: "Forward meeting successfully",
                    });
                    this.$emit("update:visible", false);
                    this.$emit("success");
                  } else {
                    this.$message({
                      type: "error",
                      message: res.msg,
                    });
                  }
                })
                .catch((err) => {
                  this.$message({
                    type: "info",
                    message: "error: " + err,
                  });
                });
            }
          });
        }
      });
    },
    getForwardList() {
      this.axios
        .get(
          `/meeting/getForwardList?meetingHost=${
            this.forwardForm.Host == "" ? "" : this.forwardForm.Host
          }`
        )
        .then(({ data }) => {
          this.forwardList = data;
        });
    },
  },
};
</script>

<style lang="scss">
.forward-dialog {
  min-width: 500px;
  .el-scrollbar.dialog {
    max-height: 100%;
    width: 500px;
    min-width: 500px;
  }
  .el-dialog__header {
    padding: 20px;
    text-align: left;
    .el-dialog__title {
      color: black;
      font-size: 18px;
      font-weight: bold;
      //text-align:left;
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__footer {
    padding: 10px 15px 15px;
  }
  .form-wrap {
    height: 250px;
    .el-scrollbar {
      text-align: left;
      height: 100%;
      .el-scrollbar__wrap {
        overflow-x: hidden;
        text-align: left;
      }
    }
    .el-form {
      padding: 5px 15px 0;
      .content {
        width: 90%;
        padding-left: 10%;
      }
      .el-form-item {
        margin-bottom: 15px;
        .el-form-item__label {
          padding: 0;
        }
      }
      h3 + p {
        margin-top: 5px;
        font-size: 14px;
      }
      .el-row:last-child {
        margin-top: 10px;
      }
      .el-select {
        width: 100%;
      }
      .comment-input {
        .el-input--mini .el-input__inner {
          height: 80px;
          line-height: 28px;
        }
      }
    }
  }
  .dialog-footer {
    text-align: center;
  }
}
</style>
